import { toast } from 'react-toastify';
import API from '../apiClient';

export const UpdateAdminUser = (entity,payload) => {
    return new Promise((resolve,reject) => {
        API.put(`/users/admin/${encodeURIComponent(entity)}`,payload)
        .then(response => {
            resolve(response);
        }) .catch(error =>{
            reject(error)
            console.log(error)
          });
    })

}

export const UpdateUserSelf = (entity, payload) => {
    return new Promise((resolve, reject) => {
        API.put(`/users/${encodeURIComponent(entity)}`, payload)
        .then(response => {
            resolve(response);
        }).catch(error => {
            reject(error);
            console.log(error);
        });
    });
};

export const ReganarateSignupCode = (entity,payload) => {
    return new Promise((resolve,reject) => {
        API.put(`/users/generateSignupCode/${encodeURIComponent(entity)}`,payload)
        .then(response => {
            resolve(response);
        }) .catch(error =>{
            reject(error)
            console.log(error)
          });
    })

}

export const DeleteUser = (entity) => {
    return new Promise((resolve,reject) => {
        API.post(`/users/${encodeURIComponent(entity)}`)
        .then(response => {
            resolve(response);
        }) .catch(error =>{
            reject(error)
            console.log(error)
          });
    })

}

// for get the data in MyProfileView
export const GetMyProfileView = (temp_account_id) => {
    return new Promise((resolve) => {
      API.get(`/users/${encodeURIComponent(temp_account_id)}`)
        .then(response => {
          resolve(response); 
        })
        .catch(error =>{
          toast.error(error)
          console.log(error)
        }); 
    });
  };